<div class="navbar">
    <!-- This is the hamburger menu that triggers below 350px -->
    <div class="mobile-version__drawer-container">
        <button mat-button class="menu-button" (click)="sidenav.toggle()">
            <mat-icon>{{ isMenuOpen ? "menu_open" : "menu" }}</mat-icon>
        </button>
        <mat-sidenav-container class="sidenav-container">
            <mat-sidenav #sidenav autoFocus="false" mode="over" [(opened)]="isMenuOpen" class="sidenav"
                (click)="onSidenavClick()">
                <div class="drawer__buttons">
                    <mat-accordion class="sidenav-accordion">
                        <p routerLink="/aplicatii" class="sidenav-link"
                            [class.menu-active]="'/aplicatii' === activeRoute" (click)="setActiveRoute('/aplicatii')">
                            <img src="/assets/icons/apps.svg" alt="" />
                            <span>Aplicații</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('auth-module.gallery.list')" routerLink="/galerie"
                            class="sidenav-link" [class.menu-active]="'/galerie' === activeRoute"
                            (click)="setActiveRoute('/galerie')">
                            <img src="/assets/icons/gallery.svg" alt="" />
                            <span>Galerie</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('auth-module.clients.list')" routerLink="/clienti"
                            class="sidenav-link" [class.menu-active]="'/clienti' === activeRoute"
                            (click)="setActiveRoute('/clienti')">
                            <img src="/assets/icons/clients.svg" alt="" />
                            <span>Instituții</span>
                        </p>
                        <p routerLink="/settings" class="sidenav-link" [class.menu-active]="'/settings' === activeRoute"
                            (click)="setActiveRoute('/settings')">
                            <img src="/assets/icons/settings.svg" alt="" />
                            <span>Setări</span>
                        </p>

                        <mat-expansion-panel class="sidenav-accordion" (opened)="panelOpenState3 = true"
                            (closed)="panelOpenState3 = false">
                            <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState3">
                                <mat-panel-title class="sidenav-accordion">
                                    <div class="panel-title">
                                        <img src="/assets/icons/cetatean.svg" alt="" />
                                        <span>Instituții</span>
                                    </div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <p *ngIf="permissionsService.hasPermission('auth-module.clients.list')"
                                routerLink="/clienti" class="settings-option-menu"
                                [class.menu-active]="'/clienti' === activeRoute" (click)="setActiveRoute('/clienti')">
                                <img src="/assets/icons/cereri.svg" alt="" />
                                <span>Permisiuni Instituții</span>
                            </p>
                            <p class="settings-option-menu" routerLink="/documente-publice"
                                [class.menu-active]="'/documente-publice' === activeRoute"
                                (click)="setActiveRoute('/documente-publice')">
                                <img src="/assets/icons/confirmed-docs.svg" alt="" />
                                <span>Documente Publice</span>
                            </p>
                            <p class="settings-option-menu" routerLink="/operatori-institutii"
                                [class.menu-active]="'/operatori-institutii' === activeRoute"
                                (click)="setActiveRoute('/operatori-institutii')">
                                <img src="/assets/icons/confirmed-docs.svg" alt="" />
                                <span>Operatori Instituții</span>
                            </p>
                            <p routerLink="/institutii-settings" class="settings-option-menu"
                                [class.menu-active]="'/institutii-settings' === activeRoute"
                                (click)="setActiveRoute('/institutii-settings')">
                                <img src="/assets/icons/settings.svg" alt="" />
                                <span>Setări</span>
                            </p>
                        </mat-expansion-panel>
                        <mat-expansion-panel *ngIf="permissionsService.hasPermission('auth-module.bulevart.bulevart-gallery.list') || 
                            permissionsService.hasPermission('auth-module.bulevart-settings.access')
                        " class="sidenav-accordion" (opened)="panelOpenState5 = true"
                            (closed)="panelOpenState5 = false">
                            <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState5">
                                <mat-panel-title class=" sidenav-accordion">
                                    <img src="/assets/icons/bulevart.svg" alt="" />
                                    <span>Bulevart</span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <p *ngIf="permissionsService.hasPermission('auth-module.bulevart.bulevart-gallery.list')"
                                class="settings-option-menu" routerLink="/bulevart-gallery"
                                [class.menu-active]="'/bulevart-gallery' === activeRoute"
                                (click)="setActiveRoute('/bulevart-gallery')">
                                <img src="/assets/icons/gallery.svg" alt="" />
                                <span>Galerie</span>
                            </p>
                            <p *ngIf="permissionsService.hasPermission('auth-module.bulevart-settings.access')"
                                class="settings-option-menu" routerLink="/bulevart-settings"
                                [class.menu-active]="'/bulevart-settings' === activeRoute"
                                (click)="setActiveRoute('/bulevart-settings')">
                                <img src="/assets/icons/settings.svg" alt="" />
                                <span>Setări</span>
                            </p>
                        </mat-expansion-panel>
                        <mat-expansion-panel *ngIf="permissionsService.hasPermission('auth-module.solicitari.list') || 
                                permissionsService.hasPermission('auth-module.pre-inrolati.list') ||
                                permissionsService.hasPermission('auth-module.citizen.list') ||
                                permissionsService.hasPermission('auth-module.beneficiari.list') ||
                                permissionsService.hasPermission('auth-module.sablon-cerere.list')
                            " class="sidenav-accordion" (opened)="panelOpenState1 = true"
                            (closed)="panelOpenState1 = false">
                            <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState1">
                                <mat-panel-title class="sidenav-accordion">
                                    <div class="panel-title">
                                        <img src="/assets/icons/cetatean.svg" alt="" />
                                        <span>Cetățean</span>
                                    </div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <p *ngIf="permissionsService.hasPermission('auth-module.solicitari.list')"
                                routerLink="/requests" class="settings-option-menu"
                                [class.menu-active]="'/requests' === activeRoute" (click)="setActiveRoute('/requests')">
                                <img src="/assets/icons/cereri.svg" alt="" />
                                <span>Solicitări</span>
                            </p>
                            <p *ngIf="permissionsService.hasPermission('auth-module.pre-inrolati.list')"
                                routerLink="/conturi-preinrolate" class="settings-option-menu"
                                [class.menu-active]="'/conturi-preinrolate' === activeRoute"
                                (click)="setActiveRoute('/conturi-preinrolate')">
                                <img src="/assets/icons/user-check.svg" alt="" />
                                <span>Conturi preînrolate</span>
                            </p>
                            <p *ngIf="permissionsService.hasPermission('auth-module.citizen.list')"
                                routerLink="/conturi-cetatean" class="settings-option-menu"
                                [class.menu-active]="'/conturi-cetatean' === activeRoute"
                                (click)="setActiveRoute('/conturi-cetatean')">
                                <img src="/assets/icons/user.svg" alt="" />
                                <span>Conturi cetățean</span>
                            </p>
                            <p *ngIf="permissionsService.hasPermission('auth-module.beneficiari.list')"
                                class="settings-option-menu" routerLink="/beneficiari"
                                [class.menu-active]="'/beneficiari' === activeRoute"
                                (click)="setActiveRoute('/beneficiari')">
                                <img src="/assets/icons/user.svg" alt="" />
                                <span>Beneficiari</span>
                            </p>
                            <p *ngIf="permissionsService.hasPermission('auth-module.settings.sabloane-cerere.list')"
                                class="settings-option-menu" routerLink="/sabloane-requests"
                                [class.menu-active]="'/sabloane-requests' === activeRoute"
                                (click)="setActiveRoute('/sabloane-requests')">
                                <img src="/assets/icons/drawer.svg" alt="" />
                                <span>Șabloane Solicitări</span>
                            </p>
                            <p *ngIf="permissionsService.hasPermission('auth-module.solicitari.citizen-documents.list')"
                                class="settings-option-menu" routerLink="/documente-cetatean"
                                [class.menu-active]="'/documente-cetatean' === activeRoute"
                                (click)="setActiveRoute('/documente-cetatean')">
                                <img src="/assets/icons/docs.svg" alt="" />
                                <span>Documente</span>
                            </p>
                            <p *ngIf="permissionsService.hasPermission('auth-module.solicitari.confirmare-documents.list')"
                                class="settings-option-menu" routerLink="/confirmare-documente"
                                [class.menu-active]="'/confirmare-documente' === activeRoute"
                                (click)="setActiveRoute('/confirmare-documente')">
                                <img src="/assets/icons/confirmed-docs.svg" alt="" />
                                <span>Confirmare Documente</span>
                            </p>
                            <p *ngIf="permissionsService.hasPermission('auth-module.settings.sabloane-cerere.list')"
                                class="settings-option-menu" routerLink="/rapoarte"
                                [class.menu-active]="'/rapoarte' === activeRoute" (click)="setActiveRoute('/rapoarte')">
                                <img src="/assets/icons/rapoarte.svg" alt="" />
                                <span>Rapoarte</span>
                            </p>
                            <p *ngIf="permissionsService.hasPermission('auth-module.settings.sabloane-cerere.list')"
                                class="settings-option-menu" routerLink="/borderou"
                                [class.menu-active]="'/borderou' === activeRoute" (click)="setActiveRoute('/borderou')">
                                <img src="/assets/icons/borderou.svg" alt="" />
                                <span>Borderou</span>
                            </p>
                            <p *ngIf="true" class="settings-option-menu" routerLink="/recenzii"
                                [class.menu-active]="'/recenzii' === activeRoute" (click)="setActiveRoute('/recenzii')">
                                <img src="/assets/icons/star.svg" alt="" />
                                <span>Recenzii</span>
                            </p>
                        </mat-expansion-panel>

                        <mat-expansion-panel *ngIf="permissionsService.hasPermission('auth-module.ghiseu.list') || 
                                permissionsService.hasPermission('auth-module.ghiseu.ghiseu-dashboard.list') ||
                                permissionsService.hasPermission('auth-module.ghiseu.ghiseu-programari.list') || 
                                permissionsService.hasPermission('auth-module.ghiseu.notificari-ghiseu.list') ||
                                permissionsService.hasPermission('auth-module.ghiseu.borderou-automat.list') ||
                                permissionsService.hasPermission('auth-module.ghiseu-settings.access-ghiseu')
                            " class="sidenav-accordion" (opened)="panelOpenState4 = true"
                            (closed)="panelOpenState4 = false">
                            <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState4">
                                <mat-panel-title class="sidenav-accordion">
                                    <div class="panel-title">
                                        <img src="/assets/icons/administrative.svg" alt="" />
                                        <span>Ghișeul Unic</span>
                                    </div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <p *ngIf="permissionsService.hasPermission('auth-module.ghiseu.ghiseu-dashboard.list')"
                                class="settings-option-menu" routerLink="/ghiseul-unic-dashboard"
                                [class.menu-active]="'/ghiseul-unic-dashboard' === activeRoute"
                                (click)="setActiveRoute('/ghiseul-unic-dashboard')">
                                <img class="sidenav-request-btn" src="/assets/icons/rapoarte.svg" alt="" />
                                <span>Dashboard</span>
                            </p>
                            <p *ngIf="permissionsService.hasPermission('auth-module.ghiseu.list')"
                                class="settings-option-menu" routerLink="/ghiseul-unic-cereri"
                                [class.menu-active]="'/ghiseul-unic-cereri' === activeRoute"
                                (click)="setActiveRoute('/ghiseul-unic-cereri')">
                                <img class="sidenav-request-btn" src="/assets/icons/cereri.svg" alt="" />
                                <span>Solicitări</span>
                            </p>
                            <p *ngIf="permissionsService.hasPermission('auth-module.ghiseu.ghiseu-programari.list')"
                                class="settings-option-menu" routerLink="/ghiseul-unic-programari"
                                [class.menu-active]="'/ghiseul-unic-programari' === activeRoute"
                                (click)="setActiveRoute('/ghiseul-unic-programari')">
                                <img class="sidenav-request-btn" src="/assets/icons/programari.svg" alt="" />
                                <span>Programări</span>
                            </p>
                            <p *ngIf="permissionsService.hasPermission('auth-module.ghiseu.notificari-ghiseu.list')"
                                class="settings-option-menu" routerLink="/ghiseul-unic-notificari"
                                [class.menu-active]="'/ghiseul-unic-notificari' === activeRoute"
                                (click)="setActiveRoute('/ghiseul-unic-notificari')">
                                <img src="/assets/icons/notificari.svg" alt="" />
                                <span>Notificări</span>
                            </p>
                            <p *ngIf="permissionsService.hasPermission('auth-module.ghiseu.borderou-automat.list')"
                                class="settings-option-menu" routerLink="/ghiseul-unic-borderouri-automate"
                                [class.menu-active]="'/ghiseul-unic-borderouri-automate' === activeRoute"
                                (click)="setActiveRoute('/ghiseul-unic-borderouri-automate')">
                                <img class="sidenav-request-btn" src="/assets/icons/borderou.svg" alt="" />
                                <span>Borderouri Automate</span>
                            </p>
                            <p *ngIf="permissionsService.hasPermission('auth-module.ghiseu-settings.access-ghiseu')"
                                routerLink="/ghiseul-unic-settings" class="settings-option-menu"
                                [class.menu-active]="'/ghiseul-unic-settings' === activeRoute"
                                (click)="setActiveRoute('/ghiseul-unic-settings')">
                                <img src="/assets/icons/settings.svg" alt="" />
                                <span>Setări</span>
                            </p>

                            <mat-expansion-panel
                                *ngIf="permissionsService.hasPermission('auth-module.ghiseu.ghiseu-programari.list')"
                                class="sidenav-accordion" (opened)="panelOpenState6 = true"
                                (closed)="panelOpenState6 = false">
                                <mat-expansion-panel-header class="sidenav-accordion"
                                    [class.hide-line]="panelOpenState6">
                                    <mat-panel-title class="sidenav-accordion">
                                        <img src="../../../../assets/icons/programari.svg" alt="" />
                                        <span> Calendar</span>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>

                                <mat-expansion-panel *ngFor="let module of sidenavService.getGhiseuModules()"
                                    class="sidenav-accordion" (opened)="panelOpenState = true"
                                    (closed)="panelOpenState = false">
                                    <mat-expansion-panel-header class="sidenav-accordion">
                                        <mat-panel-title class="sidenav-accordion">
                                            <div class="panel-title panel-title-overflow">
                                                <img src="../../../../assets/icons/programari.svg" alt="" />
                                                <span> {{ module.name }}</span>
                                            </div>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>

                                    <ng-container *ngFor="let locatieActiva of sidenavService.getGhiseuLocatiiActive()">
                                        <p *ngIf="locatieActiva.id_modul === module.id" class="settings-option-menu"
                                            [class.menu-active]="('/ghiseul-unic-programari-view/' + locatieActiva.id) === activeRoute"
                                            (click)="navigateToProgramariView(module.id, locatieActiva.id_locatie)">
                                            <img src="../../../../assets/icons/location-dot-solid.svg" alt="" />
                                            <span>{{ locatieActiva.nume_locatie }}</span>
                                        </p>
                                    </ng-container>
                                </mat-expansion-panel>
                            </mat-expansion-panel>
                        </mat-expansion-panel>

                        <mat-expansion-panel class="sidenav-accordion" (opened)="panelOpenState2 = true"
                            (closed)="panelOpenState2 = false">
                            <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState2">
                                <mat-panel-title class="sidenav-accordion">
                                    <div class="panel-title">
                                        <img src="/assets/icons/administrative.svg" alt="" />
                                        <span>Administrativ</span>
                                    </div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <p routerLink="/admin-settings" class="settings-option-menu"
                                [class.menu-active]="'/admin-settings' === activeRoute"
                                (click)="setActiveRoute('/admin-settings')">
                                <img src="/assets/icons/settings.svg" alt="" />
                                <span>Setări</span>
                            </p>
                        </mat-expansion-panel>
                    </mat-accordion>

                    <div class="footer">
                        <div class="logout-button" (click)="logout()">
                            <img src="assets/icons/logout.svg" alt="Deconectare" />
                            <div class="logout-button--text">Deconectare</div>
                        </div>
                    </div>
                </div>
            </mat-sidenav>
            <mat-sidenav-content>
                <main>
                    <!-- <router-outlet></router-outlet> -->
                </main>
            </mat-sidenav-content>
        </mat-sidenav-container>
    </div>



    <button type="button" class="admin" [class.admin-active]="isPopoverOpen" [popover]="popTemplate"
        #adminPopover="bs-popover" [adaptivePosition]="true" container="body" boundariesElement="scrollParent"
        placement="auto" (click)="togglePopover()">
        <div class="username">{{ username }}</div>
        <div class="username__icon">
            <div class="username__icon--letters">{{ usernameLetters }}</div>
        </div>
    </button>

    <ng-template #popTemplate>
        <div class="popover">
            <div class="row">
                <div class="col d-flex flex-column">
                    <div class="content d-flex flex-column">
                        <div class="username">{{ username }}</div>
                        <div class="description">Membru din data de {{memberSince | date }}</div>
                    </div>
                    <div class="actions d-flex justify-content-between mt-2">
                        <button (click)="closePopover()" type="button" class="btn btn-light">Închide</button>
                        <button (click)="openResetPasswordComp()" type="button" class="btn btn-light">Profil</button>
                        <button (click)="logout()" type="button" class="btn btn-light">Deconectare</button>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <div class="notification" [popover]="popTemplateNotifications" [adaptivePosition]="true"
        #notificationsPopover="bs-popover" placement="bottom" container="body" boundariesElement="scrollParent"
        (click)="toggleNotificationsPopover()">
        <div class="notifications" [ngClass]="{ 'move-up': !userNotifications && !isLoading }">
            <mat-spinner color="primary" diameter="40" *ngIf="isLoading"></mat-spinner>
            <img src="assets/icons/icon-bell.svg" alt="Notificari" />
            <div class="notifications--chip" [ngClass]="{ 'hide-chip': isLoading }">
                <span *ngIf="!isLoading && userNotifications">{{ userNotifications }}</span>
            </div>
        </div>

    </div>

    <ng-template #popTemplateNotifications>
        <p class="title"><strong>Cetățean</strong></p>
        <div class="notification-popup d-flex flex-column">
            <div class="notification-message-container">
                <button type="button"
                    class=" btn btn-light subtitle d-flex justify-content-start align-items-center gap-2"
                    (click)="onButtonClick({id: '1', name: 'Cereri'})">
                    <i class="fa-solid fa-envelope info"></i> {{notification['urbanism_modified']}} Solicitări necesită
                    atenția dvs.
                </button>

                <button type="button"
                    class="btn btn-light subtitle d-flex justify-content-start align-items-center gap-2"
                    (click)="onButtonClick({id: '2', name: 'Mesaje interne'})">
                    <i class="fa-solid fa-triangle-exclamation warning"></i> {{notification['urbanism_messages']}}
                    Mesaje interne pentru dvs.
                </button>
            </div>
        </div>
        <br>
        <p class="title"><strong>Ghișeu</strong></p>
        <div class="notification-popup d-flex flex-column">
            <div class="notification-message-container">
                <button type="button"
                    class=" btn btn-light subtitle d-flex justify-content-start align-items-center gap-2"
                    (click)="onButtonClickGhiseu({id: '2', name: 'Mesaje interne'})">
                    <i class="fa-solid fa-triangle-exclamation warning"></i> {{notification['ghiseul_unic_messages']}}
                    Mesaje interne pentru dvs.
                </button>
            </div>
        </div>
    </ng-template>
</div>